export default "__VITE_ASSET__74f3e37d__"